import { render } from "./approveTrustForm.vue?vue&type=template&id=9a1f89d8&scoped=true"
import script from "./approveTrustForm.vue?vue&type=script&lang=js"
export * from "./approveTrustForm.vue?vue&type=script&lang=js"

import "./approveTrustForm.vue?vue&type=style&index=0&id=9a1f89d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1f89d8"]])

export default __exports__